import React from 'react';

// Attention flags need a reviewer's eye; every other flag code is informational.
export const ATTENTIONFLAGS = ["ownerspend", "novoucher", "tip", "alias", "split", "quoteonly", "missingtaxinv", "recharge", "prepaid", "unclearnature"];

export function hasattentionflag(line: any) {
  for (let f = 0; line.flags && f < line.flags.length; f++) {
    if (ATTENTIONFLAGS.indexOf(line.flags[f]) >= 0) return true;
  }
  return false;
}

export function flagchipclass(code: string) {
  return "chip " + (ATTENTIONFLAGS.indexOf(code) >= 0 ? "chip-flag-attention" : "chip-flag-info");
}

export function fmtdate(value: any) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return day + "/" + month + "/" + date.getFullYear();
}

export function fmtamount(value: any) {
  if (value == null || Number(value) == 0) return "";
  return Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const TableLine = ({ linedata, ledgermap, openline, approveline, resetline }: any) => {
  const rows = [];
  for (let i = 0; i < linedata.length; i++) {
    const line = linedata[i];
    const narration = line.narration || "";
    const flagchips = [];
    for (let f = 0; line.flags && f < line.flags.length; f++) {
      flagchips.push(<span key={line.flags[f]} className={flagchipclass(line.flags[f])}>{line.flags[f]}</span>);
    }

    rows.push(
      <tr key={line._id} className={line.balancecheck == "check" ? "row-check" : ""}>
        <td>
          <select
            className="action-select"
            value=""
            onChange={(e) => {
              if (e.target.value == "View") openline(line, "viewline");
              if (e.target.value == "Approve") approveline(line);
              if (e.target.value == "Edit") openline(line, "editline");
              if (e.target.value == "Flag") openline(line, "flagline");
              if (e.target.value == "Reset") resetline(line);
            }}
          >
            <option value="">Select…</option>
            <option value="View">View</option>
            <option value="Approve">Approve</option>
            <option value="Edit">Edit</option>
            <option value="Flag">Flag</option>
            <option value="Reset">Reset to pending</option>
          </select>
        </td>
        <td>{line.linenumber}</td>
        <td className="nowrap">{fmtdate(line.bankdate)}</td>
        <td className="narration-cell" title={narration}>{narration.length > 60 ? narration.slice(0, 60) + "…" : narration}</td>
        <td className="amount">{fmtamount(line.debit)}</td>
        <td className="amount">{fmtamount(line.credit)}</td>
        <td>{line.voucherref}</td>
        <td>{line.vendor}</td>
        <td className="amount">{fmtamount(line.voucheramount)}</td>
        <td className="amount" title={line.differencereason || ""}>{fmtamount(line.difference)}</td>
        <td>{line.finalledger}</td>
        <td>{ledgermap[line.finalledger] || ""}</td>
        <td>{line.vatstatus}</td>
        <td><span className={"chip chip-" + line.confidence}>{line.confidence}</span></td>
        <td>{flagchips}</td>
        <td><span className={"chip chip-" + line.reviewstatus}>{line.reviewstatus}</span></td>
      </tr>
    );
  }
  if (rows.length == 0) {
    rows.push(
      <tr key="empty">
        <td colSpan={16} className="empty-row">No lines</td>
      </tr>
    );
  }

  return (
    <div className="table-scroll">
      <table className="grid grid-wide">
        <thead>
          <tr>
            <th>action</th>
            <th>#</th>
            <th>date</th>
            <th>narration</th>
            <th>debit</th>
            <th>credit</th>
            <th>voucher ref</th>
            <th>vendor</th>
            <th>voucher amt</th>
            <th>difference</th>
            <th>final ledger</th>
            <th>Tally group</th>
            <th>VAT status</th>
            <th>confidence</th>
            <th>AI flags</th>
            <th>review</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
};

export default TableLine;
